(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fgh-promotion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const syncPromotions = () => {
    document.querySelectorAll('[data-fgh-promotion-expires]').forEach((banner) => {
      const remaining = Date.parse(banner.dataset.fghPromotionExpires) - Date.now();
      if (remaining <= 0) {
        banner.hidden = true;
      } else if (!banner.dataset.fghExpiryScheduled) {
        banner.dataset.fghExpiryScheduled = 'true';
        window.setTimeout(() => { banner.hidden = true; }, Math.min(remaining, 2147483647));
      }
    });
  };
  syncPromotions();
  document.addEventListener('shopify:section:load', syncPromotions);
  window.addEventListener('pageshow', syncPromotions);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
